/**
 * O texto do catálogo no idioma de quem está olhando (AB#85634, AC37).
 *
 * O Prodgy acrescenta título, descrição e changelog em volta do pacote, e é só
 * isso que ganha idioma. O `SKILL.md`, a licença e os materiais de apoio são o
 * produto da skill — como o README de um software, quem a lê no repositório a
 * lê no idioma em que foi escrita.
 *
 * Retaguarda em cascata, e nunca vazio: o idioma pedido, senão o canônico do
 * pacote, senão qualquer tradução existente. A última etapa evita o caso em que
 * alguém traduziu só para um idioma e o cartão apareceria em branco para os
 * demais.
 */
export const textoDaSkill = (
  canonico: string | null | undefined,
  traducoes: Record<string, string> | null | undefined,
  idioma: string,
): string => {
  const curto = idioma.split("-")[0] ?? idioma;

  const traduzido = traducoes?.[idioma]?.trim() || traducoes?.[curto]?.trim();
  if (traduzido) return traduzido;

  if (canonico?.trim()) return canonico;

  const qualquer = Object.values(traducoes ?? {}).find((texto) => texto?.trim());

  return qualquer ?? "";
};
